import styled from 'styled-components';

export const StyledFieldProposalCard = styled.div`
   display: flex;
   flex-direction: column;
   gap: 8px;
   padding: 12px;
   border: 1px solid ${(props) => props.theme.borderLighter};
   border-radius: 8px;
   background-color: ${(props) => props.theme.backgroundBody};
`;

StyledFieldProposalCard.displayName = 'StyledFieldProposalCard';

export const StyledFieldProposalCardHeader = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 8px;
`;

StyledFieldProposalCardHeader.displayName = 'StyledFieldProposalCardHeader';

export const StyledFieldProposalCardLabel = styled.h4`
   margin: 0;
   font-size: 12px;
   font-weight: 600;
   color: ${(props) => props.theme.secondary};
   text-transform: uppercase;
   letter-spacing: 0.5px;
`;

StyledFieldProposalCardLabel.displayName = 'StyledFieldProposalCardLabel';

type StyledFieldProposalCardStatusProps = {
   $status: 'pending' | 'accepted' | 'rejected';
};

export const StyledFieldProposalCardStatus = styled.span<StyledFieldProposalCardStatusProps>`
   font-size: 11px;
   font-weight: 500;
   padding: 2px 6px;
   border-radius: 10px;

   ${(props) => {
      if (props.$status === 'accepted') {
         return `
            background-color: ${props.theme.successLighter};
            color: ${props.theme.success};
            border: 1px solid ${props.theme.successLight};
         `;
      }
      if (props.$status === 'rejected') {
         return `
            background-color: ${props.theme.backgroundLighter};
            color: ${props.theme.secondary};
            border: 1px solid ${props.theme.borderLighter};
         `;
      }
      return '';
   }}
`;

StyledFieldProposalCardStatus.displayName = 'StyledFieldProposalCardStatus';

export const StyledFieldProposalText = styled.p`
   margin: 0;
   font-size: 13px;
   color: ${(props) => props.theme.textBody};
   line-height: 1.5;
   white-space: pre-wrap;
   max-height: 150px;
   overflow-y: auto;
   padding: 8px 10px;
   border: 1px solid ${(props) => props.theme.borderLighter};
   border-radius: 6px;
   background-color: ${(props) => props.theme.backgroundLighter};
`;

StyledFieldProposalText.displayName = 'StyledFieldProposalText';

export const StyledVerificationBadge = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 4px;
   padding: 2px 8px;
   border-radius: 12px;
   font-size: 11px;
   font-weight: 500;
   background-color: ${(props) => props.theme.warningLighter};
   color: ${(props) => props.theme.textBody};
   border: 1px solid ${(props) => props.theme.warningLight};
   width: fit-content;
`;

StyledVerificationBadge.displayName = 'StyledVerificationBadge';

export const StyledFieldProposalTextarea = styled.textarea`
   width: 100%;
   min-height: 80px;
   padding: 8px 10px;
   font-size: 13px;
   font-family: inherit;
   color: ${(props) => props.theme.textBody};
   background-color: ${(props) => props.theme.backgroundLighter};
   border: 1px solid ${(props) => props.theme.borderLighter};
   border-radius: 6px;
   line-height: 1.5;
   resize: vertical;
   box-sizing: border-box;

   &:focus {
      outline: 2px solid ${(props) => props.theme.primary};
      outline-offset: 0;
   }

   &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      resize: none;
   }
`;

StyledFieldProposalTextarea.displayName = 'StyledFieldProposalTextarea';
